const THEME = Symbol.for('es-theme');
const LOCAL_STORAGE_KEY = 'es-theme';

export { LOCAL_STORAGE_KEY, THEME };
